export const FLIGHT_PACKAGE             = Symbol('FLIGHT_PACKAGE');
export const ABROAD_HOTEL               = Symbol('ABROAD_HOTEL');
export const HOTEL_FLIGHT_PACKAGE       = Symbol('HOTEL_FLIGHT_PACKAGE');
export const DOMESTIC_FLIGHT            = Symbol('DOMESTIC_FLIGHT');
export const DOMESTIC_HOTEL             = Symbol('DOMESTIC_HOTEL');
export const DOMESTIC_PACKAGE           = Symbol('DOMESTIC_PACKAGE');
export const ORG_TOUR                   = Symbol('ORG_TOUR');
export const FLY_DRIVE                  = Symbol('FLY_DRIVE');
export const HOTEL_FLIGHT_CAR_PACKAGE   = Symbol('HOTEL_FLIGHT_CAR_PACKAGE');
export const DYNAMIC_PACKAGE            = Symbol('DYNAMIC_PACKAGE');
export const COMBINED                   = Symbol('COMBINED');

export default Object.freeze([
    FLIGHT_PACKAGE,
    ABROAD_HOTEL,
    HOTEL_FLIGHT_PACKAGE,
    DOMESTIC_FLIGHT,
    DOMESTIC_HOTEL,
    DOMESTIC_PACKAGE,
    ORG_TOUR,
    FLY_DRIVE,
    HOTEL_FLIGHT_CAR_PACKAGE,
    DYNAMIC_PACKAGE,
    COMBINED
]);